import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=6cfc5161&"
import script from "./GalleryCard.vue?vue&type=script&lang=js&"
export * from "./GalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports